module.exports = __webpack_public_path__ + "img/icons.c5e93325.svg";